import "../assets/link.scss";

/**
 * Компонент ссылки, которая при нажатии будет открываться в программе,
 * работающей с электронной почтой.
 * 
 * @param {*} props 
 * @returns 
 */
export function LinkMail(props) {
  const {to, children = []} = props;
  return <a href={`mailto:${to}`} className={'link'}>{children}</a>;
}